import { AxiosError } from 'axios';

import { axiosInstanceForTenantAPI } from '../../assets/utils/axiosInstance';
import { FinalReportData } from '../../interfaces/FinalReportData';


type ItemType = {
  id: number;
  report: string;
  name: string;
  associated_department: string;
  notification_reason: string;
  date_informed_at: string;
};

interface ModifiedFinalReportData extends FinalReportData {
  informed_individuals: Array<ItemType>;
  has_informed_individuals: boolean;
}

export const reportFetcher = async (url: string, id: string | undefined) => {
  if (!id) {
    throw new Error('No final report found.');
  }
  const response = await axiosInstanceForTenantAPI()
    .get<ModifiedFinalReportData>(`${url}/${id}`)
    .catch((err: Error | AxiosError) => {
      throw err;
    });
  return response.data;
};
